import React from "react";
import { HOCType } from "../constants/types";
import { ModalProvider } from "../contexts/ModalContext";

export const withModalProvider: HOCType = (WrappedComponent) => (props) => (
  <ModalProvider>
    <WrappedComponent {...props} />
  </ModalProvider>
);
